import type { IconData } from '@stacksjs/iconify-core'

export const circleAndSquareShapeSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 19.5c0 7.095 4.105 13.23 10.069 16.163A183 183 0 0 1 11.5 30.5c0-4.521.14-7.815.305-10.12c.331-4.65 3.926-8.244 8.575-8.575c2.305-.164 5.599-.305 10.12-.305c1.94 0 3.656.026 5.163.069C32.73 5.605 26.595 1.5 19.5 1.5c-9.941 0-18 8.059-18 18m19.093-4.703c2.225-.158 5.447-.297 9.907-.297s7.682.139 9.907.297c3.16.225 5.57 2.635 5.796 5.796c.158 2.225.297 5.447.297 9.907s-.139 7.682-.297 9.907c-.226 3.16-2.636 5.57-5.796 5.796c-2.225.158-5.447.297-9.907.297s-7.682-.139-9.907-.297c-3.16-.226-5.57-2.636-5.796-5.796c-.158-2.225-.297-5.447-.297-9.907s.139-7.682.297-9.907c.225-3.16 2.635-5.57 5.796-5.796\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleAndSquareShapeSolid
